// extracted by mini-css-extract-plugin
export var list = "BlogList-module--list--96121";
export var listContainer = "BlogList-module--listContainer--bb94f";